import React from 'react';
import shortid from 'shortid';
import ImageLoader from '../../../Common/ImageLoader';
import { withRouter } from 'react-router-dom';

const BrowseByRegion = (props) => {
  return (
    <div className="browse-region">
      <h2>Featured Cities</h2>
      <div className="location-listing">
        <ul>
          {!!props.topLocations &&
            props.topLocations.length > 0 &&
            props.topLocations.map((location) => (
              <li
                key={shortid.generate()}
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push(location.url.replace('/api/v1', ''));
                }}
              >
                <ImageLoader
                  image={location.image_url}
                  fallbackImage={'/static/images/FC-Generic-Logo.webp'}
                />
                <h2>{location.name}</h2>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default withRouter(BrowseByRegion);
